export default __webpack_public_path__ + "static/male-7bfd69845b73f185b51d1949201c357f.png";